import request from '@/utils/request'

/**
 * 获取全局布局、SEO 和公开联系入口所需的站点启动信息。
 * 页面业务数据应继续由各页面按需请求，避免阻塞首屏。
 */
export function getPortalBootstrap() {
  return request.get('/portal/bootstrap')
}

export function getAbout() {
  return request.get('/portal/about')
}

export function getArticles(params) {
  return request.get('/portal/articles', { params })
}

export function getArticleDetail(id) {
  return request.get(`/portal/articles/detail/${id}`)
}

export function getArticleComments(articleId) {
  return request.get(`/portal/comments/list/${articleId}`)
}

export function createArticleComment(data) {
  return request.post('/portal/comments', data)
}

export function getRecentComments() {
  return request.get('/portal/comments/recent')
}

export function getCategories() {
  return request.get('/portal/categories')
}

export function getNotes(params) {
  return request.get('/portal/notes', { params })
}

export function getHomeNotes() {
  return request.get('/portal/notes/home')
}

export function getArchives() {
  return request.get('/portal/archives')
}

export function getLinks() {
  return request.get('/portal/links')
}

export function applyLink(data) {
  return request.post('/portal/links/apply', data)
}
